<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <form [formGroup]="updateForm" enctype="multipart/form-data">
      <div class="form-group">
        <label>رقم المجموعة</label>
        <input
          formControlName="Number"
          [class.is-invalid]="Number.invalid && Number.touched"
          type="text"
          class="form-control"
        />
        <div *ngIf="Number.errors && Number.invalid && Number.touched">
          <small class="text-danger" *ngIf="Number.errors?.required">
            رقم المجموعة مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>اقل سن مسموح بيه للطلاب</label>
        <input
          type="number"
          formControlName="StudentsMinAge"
          [class.is-invalid]="StudentsMinAge.invalid && StudentsMinAge.touched"
          class="form-control"
        />
        <div
          *ngIf="
            StudentsMinAge.errors &&
            StudentsMinAge.invalid && StudentsMinAge.touched
          "
        >
          <small class="text-danger" *ngIf="StudentsMinAge.errors?.required">
            اقل سن مسموح بيه للطلاب مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>اكبر سن مسموح بيه للطلاب</label>
        <input
          type="number"
          formControlName="StudentsMaxAge"
          [class.is-invalid]="StudentsMaxAge.invalid && StudentsMaxAge.touched"
          class="form-control"
        />
        <div
          *ngIf="
            StudentsMaxAge.errors &&
            StudentsMaxAge.invalid && StudentsMaxAge.touched
          "
        >
          <small class="text-danger" *ngIf="StudentsMaxAge.errors?.required">
            اكبر سن مسموح بيه للطلاب مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>الجنــــس</label>
        <select
          formControlName="StudentGender"
          [class.is-invalid]="StudentGender.invalid && StudentGender.touched"
          type="text"
          class="form-control"
        >
          <option value="Male">ذكـــر</option>
          <option value="Female">أنثــى</option>
        </select>
        <div
          *ngIf="
            StudentGender.errors &&
            StudentGender.invalid && StudentGender.touched
          "
        >
          <small class="text-danger" *ngIf="StudentGender.errors?.required">
            الجنــــس مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>رابط المجموعة</label>
        <input
          formControlName="ClassLink"
          [class.is-invalid]="ClassLink.invalid && ClassLink.touched"
          type="text"
          class="form-control"
        />
        <div *ngIf="ClassLink.errors && ClassLink.invalid && ClassLink.touched">
          <small class="text-danger" *ngIf="ClassLink.errors?.required">
            رابط المجموعة مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>كلمة سر لرابط المجموعة</label>
        <input
          formControlName="ClassLinkPassword"
          [class.is-invalid]="
            ClassLinkPassword.invalid && ClassLinkPassword.touched
          "
          type="password"
          class="form-control"
        />
        <div
          *ngIf="
            ClassLinkPassword.errors &&
            ClassLinkPassword.invalid && ClassLinkPassword.touched
          "
        >
          <small class="text-danger" *ngIf="ClassLinkPassword.errors?.required">
            كلمة سر لرابط المجموعة مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>تاريخ البداية</label>
        <input
          type="date"
          formControlName="StartDate"
          [class.is-invalid]="StartDate.invalid && StartDate.touched"
          class="form-control"
        />
        <div *ngIf="StartDate.errors && StartDate.invalid && StartDate.touched">
          <small class="text-danger" *ngIf="StartDate.errors?.required">
            تاريخ البداية مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>تاريخ النهاية</label>
        <input
          type="date"
          formControlName="EndDate"
          [class.is-invalid]="EndDate.invalid && EndDate.touched"
          class="form-control"
        />
        <div *ngIf="EndDate.errors && EndDate.invalid && EndDate.touched">
          <small class="text-danger" *ngIf="EndDate.errors?.required">
            تاريخ النهاية مطلوب
          </small>
        </div>
      </div>
      <div class="form-group">
        <label>الدورة التدربية </label>
        <select class="custom-select" formControlName="CourseId">
          <option *ngFor="let course of courses" value="{{ course._id }}">
            {{ course.tittle }}
          </option>
        </select>
      </div>
      
      <input
        type="submit"
        class="update btn btn-primary mt-2"
        value="تعديــــل"
        (click)="update()"
      />
    </form>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>